import React from "react";
import { FormattedMessage } from "react-intl";
import EnhanceAddToCartModal from "./EnhanceAddToCartModal";
import AddToCartModalQuery from "./AddToCartModalQuery.gql";
import Configurator from "theme/components/organisms/Configurator";
import GroupedItems, {
  hasGroupedItems,
} from "theme/modules/ProductView/GroupedItems";
import ProductAddedPopInContent from "theme/modules/ProductAddedPopIn/ProductAddedPopInContent";
import { areAllOptionsSet } from "theme/modules/AddToCart/areAllOptionsSet";
import Stack from "theme/components/atoms/Layout/Stack";
import ProductName from "theme/modules/ProductView/ProductName";
import AddProductToCart from "theme/modules/ProductView/Synthesis/AddProductToCart";

const AddToCartModal = ({
  product,
  onSuccess,
  onClose,
  selectedOptions,
  selectedBundleOptions,
  selectedCustomOptions,
  selectedGroupedItems,
  setOption,
  setBundleOption,
  setCustomOption,
  setGroupedItems,
  productAdded,
  showPopin,
}) => {
  const hasConfiguration =
    product.options?.length ||
    product.custom_options?.length ||
    product.bundleOptions?.length;

  return productAdded ? (
    <ProductAddedPopInContent product={productAdded} hidePopin={onClose} />
  ) : (
    <Stack size="2">
      <ProductName
        product={product}
        hasFinalPrice={areAllOptionsSet(
          product,
          selectedOptions,
          selectedCustomOptions,
          selectedBundleOptions,
          selectedGroupedItems
        )}
      />
      {hasConfiguration ? (
        <Configurator
          options={product.options}
          customOptions={product.custom_options}
          bundleOptions={product.bundleOptions}
          selectedOptions={selectedOptions}
          selectedBundleOptions={selectedBundleOptions}
          selectedCustomOptions={selectedCustomOptions}
          setOption={setOption}
          setCustomOption={setCustomOption}
          setBundleOption={setBundleOption}
        />
      ) : null}

      {hasGroupedItems(product) && (
        <div className="product__grouped-items">
          <GroupedItems
            product={product}
            selectedGroupedItems={selectedGroupedItems}
            setGroupedItems={setGroupedItems}
          />
        </div>
      )}

      {product.stock !== null && product.stock !== undefined && (
        <AddProductToCart
          appearance={hasConfiguration ? "default" : "center"}
          selectedOptions={selectedOptions}
          selectedCustomOptions={selectedCustomOptions}
          selectedBundleOptions={selectedBundleOptions}
          selectedGroupedItems={selectedGroupedItems}
          onProductAdded={() => {
            showPopin(product);
            onSuccess(product);
          }}
          product={product}
          label={
            <FormattedMessage
              id="modules.AddToCart.AddToCartModal.addToCart"
              defaultMessage="Add to cart"
            />
          }
          unavailableLabel={
            <FormattedMessage
              id="modules.AddToCart.AddToCartModal.unavailable"
              defaultMessage="Currently unavailable"
            />
          }
          withWishlist={false}
        />
      )}
    </Stack>
  );
};

export default EnhanceAddToCartModal({ AddToCartModalQuery })(AddToCartModal);
